export const PROJECT_DETAIL_ARCHIVABLE_STATUSES = Object.freeze(['Finished', 'Canceled']);

export const canArchiveProjectFromDetail = (status) => (
    PROJECT_DETAIL_ARCHIVABLE_STATUSES.includes(status)
);
